<div class="card makery-card makery-card-visible
{{(reservation.reservationStatus == 'SUCCEEDED')?'makery-card-success':'makery-card-accepted'}}">
  <div class="card-header ">
    <div class="row">
      <div class="col-md-7 col-xs-9 col">

        <p class="card-title">{{reservation.reservationTime + ' - ' + reservation.personCount + ' fő' }}
          <span *ngIf="reservation.survey.length">(</span>
          <span *ngFor="let survey of reservation.survey">{{survey | translate}}</span>
          <span *ngIf="reservation.survey.length">)</span>
        </p>
      </div>
      <div class="col-md-5 col-xs-3 col makery-control pr-0 ">

        <ng-container *ngIf="enabledEdit">
          <button class="btn btn-simple btn-tooltip mr-2 pr-3 pl-3  btn-hide"
                  data-animation="true"
                  data-container="body"
                  placement="bottom"
                  tooltip="{{'reservation.archive' | translate}}"
                  (click)="setArchived()">
            <i class="fas fa-eye-slash"></i>
          </button>
          <button class="btn btn-simple btn-tooltip mr-2 pr-0 pl-3 btn-hide"
                  data-animation="true"
                  data-container="body"
                  placement="bottom"
                  tooltip="{{'reservation.setEdit' | translate}}"
                  (click)="setEdit()">
            <i class="fas fa-pencil-alt"></i>
          </button>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-xs-12 col-sm-9 col-md-12 col-lg-8 col">
        <app-reservation-card-userdata [reservation]="reservation"></app-reservation-card-userdata>
      </div>
      <div class="col-xs-12 col-sm-3 col-md-12 col-lg-4 col">
        <div class="row">
          <div class="col-sm-12 col makery-control">
            <ng-container *ngIf="enabledEdit">
              <button class="btn btn-touch
                {{(reservation.reservationStatus == 'SUCCEEDED')?'btn-success':'btn-simple btn-success '}}
                   btn-tooltip mr-2"
                      data-animation="true"
                      data-container="body"
                      placement="bottom"
                      tooltip="{{'reservation.state.SUCCEEDED' | translate}}"
                      [disabled]="reservation.reservationStatus != 'ACCEPTED'"

                      (click)="success()">
                <i class="fas fa-users"></i>

              </button>
              <button class="btn btn-touch
                {{(reservation.reservationStatus == 'NOT_ARRIVED')?'btn-tumblr':'btn-simple btn-reddit '}}
                   btn-tooltip mr-2"
                      data-animation="true"
                      data-container="body"
                      placement="bottom"
                      tooltip="{{'reservation.state.NOTARRIVED' | translate}}"
                      [disabled]="reservation.reservationStatus != 'ACCEPTED'"
                      (click)="notArrived()">
                <i class="fas fa-user-times"></i>
              </button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <hr/>

    <div class="row">
      <div class="col-sm-12 col">
        <div class="row" *ngFor="let foodList of reservation.foodListForKitchen">
          <div class="col-12 col makery-food-section">
            <h3 class="font-weight-bolder">{{foodList.category.diyTypeName}}</h3>
            <ul>
              <li *ngFor="let diys of foodList.diyList" class="{{diys.status}}">
                <div class="row">
<!--                  <div class="col-md-2">-->
<!--                    <img class="lazy card-img" src="{{diys.tray}}" />-->
<!--                  </div>-->
                  <div class="col-md-7  col-sm-12">
                    <a href="javascript:void(0)" (click)="showTray(diys.tray, diys.diyName)">{{diys.count}}x {{diys.diyName}}</a>
                  </div>
                  <div class="col-md-5 col-sm-12 p-0 makery-control">
                    <ng-container *ngIf="enabledEdit">
                      <button class="btn btn-small-touch btn-simple btn-reddit
                   btn-tooltip mr-2
                    {{(diys.status == 'IN_PROGRESS' || diys.status == 'SENT_OUT')?'disabled':''}}"
                              data-animation="true"
                              data-container="body"
                              placement="bottom"
                              tooltip="{{'diyList.state.IN_PROGRESS' | translate}}"
                              [disabled]="diys.status == 'IN_PROGRESS' || diys.status == 'SENT_OUT'"
                              (click)="diyToInProgress(diys.guestDiyIds)"
                      >
                        <i class="fas fa-spinner"></i>
                      </button>
                      <button class="btn btn-small-touch btn-simple btn-success
                   btn-tooltip
                    {{( diys.status == 'SENT_OUT')?'disabled':''}}
                    {{( diys.status == null || diys.status == 'SELECTED')?'pending':''}}"
                              data-animation="true"
                              data-container="body"
                              placement="bottom"
                              tooltip="{{'diyList.state.SENT_OUT' | translate}}"
                              [disabled]="diys.status == null || diys.status == 'SELECTED' || diys.status == 'SENT_OUT'"
                              (click)="diyToSentOut(diys.guestDiyIds)"
                      >
                        <i class="fas fa-hand-holding"></i>
                      </button>
                    </ng-container>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row alert alert-warning" *ngIf="foodSelectionNotComplete">
      <div class="col-sm-12 col">
        <i class="fa-solid fa-triangle-exclamation"></i><span
        class="ml-1">{{'guest.foodSelectionNotComplete' | translate}}</span>
      </div>
    </div>

    <div class="row d-block d-md-none">
      <div class="col-12 col">
        <app-reservation-note [reservation]="reservation"></app-reservation-note>
      </div>
    </div>
  </div>
</div>

